import MonthlyDetail from './MonthlyDetail';

export default MonthlyDetail;
